import { Box, LucideIcon, Plug, Webhook, Wrench } from "lucide-react"
import { CapabilityKind, ConversationCapabilityExecutionResponseDataSchema } from "schema"
import z from "zod"

export type MessageCapabilityExecution = z.infer<
  typeof ConversationCapabilityExecutionResponseDataSchema
>

const kindIconMap: Record<string, LucideIcon> = {
  [CapabilityKind.Native]: Box,
  [CapabilityKind.Integration]: Plug,
  [CapabilityKind.Webhook]: Webhook,
  [CapabilityKind.Instruction]: Wrench,
  [CapabilityKind.MCP]: Plug,
}

export const getCapabilityExecutionIcon = (kind: MessageCapabilityExecution["capabilityKind"]) =>
  kindIconMap[kind] ?? Plug

export function getCapabilityExecutionAppearance(status: MessageCapabilityExecution["status"]) {
  switch (status) {
    case "Success":
      return {
        textColorClass: "text-success",
        borderColorClass: "border-success/20",
        bgColorClass: "group-[.active-group]:bg-success",
        ringColorClass: "ring-success",
        badgeVariant: "success",
      } as const

    case "Unsuccess":
      return {
        textColorClass: "text-testing-1",
        borderColorClass: "border-testing-1/20",
        bgColorClass: "group-[.active-group]:bg-testing-1",
        ringColorClass: "ring-testing-1",
        badgeVariant: "unsuccess",
      } as const

    case "Cached":
      return {
        textColorClass: "text-muted-foreground",
        borderColorClass: "border-border",
        bgColorClass: "group-[.active-group]:bg-muted",
        ringColorClass: "ring-border",
        badgeVariant: "cached",
      } as const

    case "Skipped":
      return {
        textColorClass: "text-warning",
        borderColorClass: "border-warning/20",
        bgColorClass: "group-[.active-group]:bg-warning",
        ringColorClass: "ring-warning",
        badgeVariant: "warning",
      } as const

    case "Error":
      return {
        textColorClass: "text-destructive",
        borderColorClass: "border-destructive/20",
        bgColorClass: "group-[.active-group]:bg-destructive",
        ringColorClass: "ring-destructive",
        badgeVariant: "negative",
      } as const
  }
}
